// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.diagnostic-panel .panel-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* Diagnostic Sections */
.diagnostic-section {
  padding: 12px;
  background: rgba(40, 40, 40, 0.6);
  border-radius: 6px;
  border-left: 3px solid #ff6b6b;
  transition: all 0.2s ease;
}

/* Primary Metrics Grid */
.primary-metrics {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  border-left: none;
  background: transparent;
  padding: 0;
}

.metric-card {
  background: rgba(40, 40, 40, 0.8);
  border-radius: 8px;
  padding: 14px;
  border: 1px solid #3a3a3a;
  transition: all 0.2s ease;
}

.metric-card:hover {
  border-color: #4a4a4a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.metric-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.metric-icon {
  font-size: 18px;
}

.metric-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888888;
}

.metric-value {
  margin: 8px 0;
  text-align: center;
}

.value-text {
  font-size: 16px;
  font-weight: 700;
}

.value-text.large {
  font-size: 32px;
  line-height: 1;
}

.value-text.birads {
  font-size: 36px;
}

/* Metric Comparison */
.metric-comparison {
  margin-top: 8px;
  text-align: center;
  font-size: 11px;
  color: #aaaaaa;
}

.metric-comparison strong {
  color: #ffffff;
}

.discrepancy-indicator {
  color: #ffa500;
  font-weight: bold;
}

/* Expandable Sections */
.diagnostic-section.expandable {
  padding: 0;
  background: transparent;
  border-left: none;
}

.section-toggle {
  width: 100%;
  padding: 12px 14px;
  background: rgba(40, 40, 40, 0.6);
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  color: #ffffff;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.section-toggle:hover {
  background: rgba(50, 50, 50, 0.7);
  border-color: #4a4a4a;
}

.toggle-icon {
  font-size: 10px;
  color: #888888;
  transition: transform 0.2s ease;
}

.section-content {
  margin-top: 8px;
  padding: 12px;
  background: rgba(35, 35, 35, 0.8);
  border-radius: 6px;
  border: 1px solid #3a3a3a;
  animation: expandSection 0.2s ease-out;
}

@keyframes expandSection {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* BI-RADS Explanation */
.birads-explanation-content {
  padding: 8px;
}

.explanation-title {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 6px;
}

.explanation-description {
  font-size: 12px;
  color: #aaaaaa;
  line-height: 1.5;
}

/* Extensible Section */
.diagnostic-section.extensible {
  border-left: 3px solid #ffa500;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
}

.extensible-content {
  padding-top: 8px;
}

.feature-placeholder {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.placeholder-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: rgba(30, 30, 30, 0.5);
  border-radius: 4px;
  font-size: 11px;
  color: #888888;
}

.placeholder-icon {
  font-size: 16px;
}

/* Filter Section */
.diagnostic-section.filter-section {
  border-left-color: #667eea;
}

.filter-header {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
}

.filter-controls {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #aaaaaa;
  cursor: pointer;
}

.filter-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #0066cc;
}

.filter-checkbox:hover {
  color: #ffffff;
}

/* Loading, Error, Empty States */
.diagnostic-panel .panel-content.loading,
.diagnostic-panel .panel-content.error,
.diagnostic-panel .panel-content.empty {
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.diagnostic-panel .panel-content.error {
  color: #ff6b6b;
}

/* Diagnostic Text Summary */
.diagnostic-section.text-summary {
  border-left-color: #667eea;
  margin-top: 12px;
}

.text-summary .section-header {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.text-summary .section-header h5 {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.stack-info {
  display: flex;
  align-items: center;
}

.stack-badge {
  display: inline-block;
  padding: 4px 10px;
  background: rgba(102, 126, 234, 0.2);
  border: 1px solid rgba(102, 126, 234, 0.4);
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #a0b0f0;
  letter-spacing: 0.3px;
}

.summary-text {
  padding: 10px;
  background: rgba(30, 30, 30, 0.5);
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.6;
  color: #d4d4d4;
}

.summary-text p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/DiagnosticSuggestionsPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;;;EAGE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".diagnostic-panel .panel-content {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* Diagnostic Sections */\n.diagnostic-section {\n  padding: 12px;\n  background: rgba(40, 40, 40, 0.6);\n  border-radius: 6px;\n  border-left: 3px solid #ff6b6b;\n  transition: all 0.2s ease;\n}\n\n/* Primary Metrics Grid */\n.primary-metrics {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  border-left: none;\n  background: transparent;\n  padding: 0;\n}\n\n.metric-card {\n  background: rgba(40, 40, 40, 0.8);\n  border-radius: 8px;\n  padding: 14px;\n  border: 1px solid #3a3a3a;\n  transition: all 0.2s ease;\n}\n\n.metric-card:hover {\n  border-color: #4a4a4a;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.metric-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.metric-icon {\n  font-size: 18px;\n}\n\n.metric-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #888888;\n}\n\n.metric-value {\n  margin: 8px 0;\n  text-align: center;\n}\n\n.value-text {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.value-text.large {\n  font-size: 32px;\n  line-height: 1;\n}\n\n.value-text.birads {\n  font-size: 36px;\n}\n\n/* Metric Comparison */\n.metric-comparison {\n  margin-top: 8px;\n  text-align: center;\n  font-size: 11px;\n  color: #aaaaaa;\n}\n\n.metric-comparison strong {\n  color: #ffffff;\n}\n\n.discrepancy-indicator {\n  color: #ffa500;\n  font-weight: bold;\n}\n\n/* Expandable Sections */\n.diagnostic-section.expandable {\n  padding: 0;\n  background: transparent;\n  border-left: none;\n}\n\n.section-toggle {\n  width: 100%;\n  padding: 12px 14px;\n  background: rgba(40, 40, 40, 0.6);\n  border: 1px solid #3a3a3a;\n  border-radius: 6px;\n  color: #ffffff;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.section-toggle:hover {\n  background: rgba(50, 50, 50, 0.7);\n  border-color: #4a4a4a;\n}\n\n.toggle-icon {\n  font-size: 10px;\n  color: #888888;\n  transition: transform 0.2s ease;\n}\n\n.section-content {\n  margin-top: 8px;\n  padding: 12px;\n  background: rgba(35, 35, 35, 0.8);\n  border-radius: 6px;\n  border: 1px solid #3a3a3a;\n  animation: expandSection 0.2s ease-out;\n}\n\n@keyframes expandSection {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* BI-RADS Explanation */\n.birads-explanation-content {\n  padding: 8px;\n}\n\n.explanation-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 6px;\n}\n\n.explanation-description {\n  font-size: 12px;\n  color: #aaaaaa;\n  line-height: 1.5;\n}\n\n/* Extensible Section */\n.diagnostic-section.extensible {\n  border-left: 3px solid #ffa500;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.extensible-content {\n  padding-top: 8px;\n}\n\n.feature-placeholder {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.placeholder-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  background: rgba(30, 30, 30, 0.5);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #888888;\n}\n\n.placeholder-icon {\n  font-size: 16px;\n}\n\n/* Filter Section */\n.diagnostic-section.filter-section {\n  border-left-color: #667eea;\n}\n\n.filter-header {\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.filter-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #aaaaaa;\n  cursor: pointer;\n}\n\n.filter-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #0066cc;\n}\n\n.filter-checkbox:hover {\n  color: #ffffff;\n}\n\n/* Loading, Error, Empty States */\n.diagnostic-panel .panel-content.loading,\n.diagnostic-panel .panel-content.error,\n.diagnostic-panel .panel-content.empty {\n  min-height: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.diagnostic-panel .panel-content.error {\n  color: #ff6b6b;\n}\n\n/* Diagnostic Text Summary */\n.diagnostic-section.text-summary {\n  border-left-color: #667eea;\n  margin-top: 12px;\n}\n\n.text-summary .section-header {\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.text-summary .section-header h5 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.stack-info {\n  display: flex;\n  align-items: center;\n}\n\n.stack-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  background: rgba(102, 126, 234, 0.2);\n  border: 1px solid rgba(102, 126, 234, 0.4);\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #a0b0f0;\n  letter-spacing: 0.3px;\n}\n\n.summary-text {\n  padding: 10px;\n  background: rgba(30, 30, 30, 0.5);\n  border-radius: 4px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #d4d4d4;\n}\n\n.summary-text p {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
